import { BaseError } from '~/lib/error/base';

export class NeedCompleteNewPasswordError extends BaseError {
  constructor() {
    super({ code: 'NEED_COMPLETE_NEW_PASSWORD', message: 'User need to complete new password' });
  }
}
